import OrganisationList from './OrganisationList';
import OrganisationShow from './OrganisationShow';

export default {
  list: OrganisationList,
  show: OrganisationShow,
};
